import { useState } from 'react'

import { $generateHtmlFromNodes } from '@lexical/html'

import { previewContentApi } from '@eastcoal/api/contract/templateEngine/previewContent'

import { ThrottleButton } from '@eastcoal/common/components/Button/ThrottleButton'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { useEditor } from '@eastcoal/editor/hooks/useEditor'
import { TemplateVariableType } from '@eastcoal/shared/enums/TemplateVariableType'

import { useEditorStyleSheetGetter } from '../../../editor/hooks/useEditorStyleSheetGetter'
import { getTemplateName } from '../../../utils/getTemplateName'
import { useTemplateVariableEntityGetter } from '../../hooks/useTemplateVariableEntityGetter'
import { useContractDesignerStore } from '../../Store/hooks/useStore'

export const PreviewButton = () => {
  const { formData, usedNodeKeys } = useContractDesignerStore(state =>
    pick(state, ['formData', 'usedNodeKeys'])
  )

  const editor = useEditor()
  const { message } = useFeedback()
  const [loading, setLoading] = useState(false)
  const getTemplateVariableEntity = useTemplateVariableEntityGetter()
  const getEditorStyleSheet = useEditorStyleSheetGetter()

  const handleClick = async () => {
    const variablePairs = getTemplateVariableEntity([...usedNodeKeys]).map(
      entity => {
        return [
          entity.property,
          entity.type === TemplateVariableType.TEXT
            ? entity.mockValue
            : JSON.parse(`${entity.mockValue}`)
        ]
      }
    )

    const variables = Object.fromEntries(variablePairs)
    const templateName = getTemplateName(formData.name)
    const edtiorStyleSheet = `<style>\n${getEditorStyleSheet()}\n</style>`
    // 使用 editor.read 提交 update 任务，以获取最新的 editor 状态
    const editorHtml = editor.read(() => $generateHtmlFromNodes(editor, null))
    const htmlContent = `${edtiorStyleSheet}\n${editorHtml}`

    console.log(htmlContent)

    try {
      setLoading(true)
      const data = await previewContentApi({
        templateName,
        htmlContent,
        variables
      })
      try {
        const url = URL.createObjectURL(data as any)
        window.open(url)
      } catch (e) {
        console.error(e)
        message.warning('预览失败', 1)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <ThrottleButton loading={loading} type='default' onClick={handleClick}>
      预览
    </ThrottleButton>
  )
}
